import React from 'react';
import PropTypes from 'prop-types';
import {SortableContainer} from 'react-sortable-hoc';
import { getCurrencyIcon } from '../../../../../../../../shared/js/get-currency-icon';
import CustomizableBlock from '../../../../../shared/customizable-block';

import SortableItem from './item';

const isRocket = process.env.CPA_ENV === 'rocket';

const Sortable = SortableContainer(props => (
	<tbody className="targeting-form__table-body">
		{ /* todo think about reverse() */ }
		{(props.fields.map((parentName, index, fields) => {
			return <SortableItem
				{...props}
				key={index}
				index={index}
				originalIndex={index}
				fileds={fields}
				parentName={parentName} />;
		}))}
	</tbody>
));

const SortableWrap = props => (
	<table className="targeting-form__table">
		<thead className="targeting-form__table-head">
			<tr>
				<th className="location"><span>{props.intl('Geo')}</span></th>
				<th className="price"><span>{props.intl('On site')}</span></th>

				<th className="price">
					<span>{props.intl('Payout %s', `, ${getCurrencyIcon('usd')}`)}</span>
				</th>

				<CustomizableBlock
					tag='th' settingId='offer-targeting-max-aff-payout' isHintAllowed={false} isHidden={!isRocket}
				>
					<span>{props.intl('%% comp')}</span>
				</CustomizableBlock>
				<CustomizableBlock
					tag='th' settingId='offer-targeting-max-aff-payout' isHintAllowed={false} isHidden={!isRocket}
				>
					<span>{props.intl('Max aff payout')}</span>
				</CustomizableBlock>
				<CustomizableBlock
					tag='th' settingId='offer-targeting-max-aff-payout' isHintAllowed={false} isHidden={isRocket}
				>
					<span>{props.intl('Max aff payout')}</span>
				</CustomizableBlock>

				{!isRocket && (
					<th className="price"><span>{props.intl('Boost %s', ', %')}</span></th>
				)}
				{!isRocket && (
					<th><span>{props.intl('Is active')}</span></th>
				)}
				{!isRocket && (
					<th><span>{props.intl('Callcenter')}</span></th>
				)}
				{!isRocket && (
					<th><span>{props.intl('Contest')}</span></th>
				)}
				{!isRocket && (
					<th><span>{props.intl('Booster')}</span></th>
				)}
				<th><span>{props.intl('Points')}</span></th>
				<th><span>{props.intl('Cap')}</span></th>
				{isRocket && (
					<th />
				)}
				{isRocket && (
					<th><span>{props.intl('Is active')}</span></th>
				)}
				<th />
			</tr>
		</thead>
		<Sortable {...props} />
	</table>
);

SortableWrap.propTypes = {
	intl: PropTypes.func
};

export default SortableWrap;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/targeting/sortable/container.js